/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'organization-data-tree-view': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M18.75 12.5v-5h-5v1.875h-3.125v-5c0-.69-.56-1.25-1.25-1.25H6.25V1.25h-5v5h5V4.375h3.125v11.25c0 .69.56 1.25 1.25 1.25h3.125v1.875h5v-5h-5v1.875h-3.125v-5h3.125V12.5h5zM5 5H2.5V2.5H5V5zm10 10h2.5v2.5H15V15zm0-6.25h2.5v2.5H15v-2.5z"/>'
  }
})
